import React, { useEffect, useState } from 'react';
import {
	Box,
	Chip,
	InputAdornment,
	List,
	ListItem,
	TablePagination,
	TextField,
	Tooltip,
	Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { SettingsTabPanel } from '..';
import { AlignGoalsSettingsTab } from './AlignGoalsSettingsTab';
import '../../../../styles/pages/admin/settings/align-goals/createGoalForm.scss';
import '../../../../styles/pages/admin/settings/align-goals/createCycleForm.scss';
import '../../../../styles/pages/admin/settings/align-goals/goalWorkflow.scss';
import { CreateGoalForm } from './GoalForm/CreateGoalForm';
import { GoalsFormsList } from './GoalForm/GoalFormListing/GoalsFormsList';
import { CreateCycleForm } from './GoalCycle/CreateCycleForm';
import { Enums } from '../../../../config/enums';
import { formatFeedbackDate } from '../../../../config/utils';
import { useSnackbar } from 'notistack';
import {
	setPaginationData,
	exportGoalFormListReport,
	exportGoalCycleListReport,
	getWorkflowReversalCycleList,
	exportWorkflowReversalReport,
} from '../../../../action/adminSettings';
import { useDispatch, useSelector } from 'react-redux';
import { GoalCyclesList } from './GoalCycle/GoalCycleListing/GoalCyclesList';
import LinearLoader from '../../../Common/Loader';
import { DownloadIcon, SearchIcon } from '../../../../config/svg/CommonSvg';
import { CrossIcon } from '../../../../config/svg/CommonSvgIcon';
import AlertDialog from '../../../Common/Dialog';
import { OKRButton } from '../../../Common/OKRButton';
import { GoalWorkflow } from './GoalWorkflow';
import { WorkflowReversalList } from './GoalWorkflow/WorkflowReversalList';
import { WorkflowReversalCycleFilter } from './GoalWorkflow/WorkflowReversalCycleFilter';

export const AlignGoalsSetting: React.FC<any> = (props: any) => {
	const {
		type,
		handleTabChange,
		a11yProps,
		setTabSelected,
		tabSelected,
		goalFormOpen,
		setGoalFormOpen,
		goalCycleOpen,
		setGoalCycleOpen,
		workflowReversalOpen,
		setWorkflowReversalOpen,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const [loader, setLoader] = useState<any>(false);
	const [pageIndex, setPageIndex] = useState<any>(1);
	const [pageSize, setPageSize] = useState<any>(Enums.TEN);
	const [goalCycleSearchValue, setGoalCycleSearchValue] = useState<string>('');
	const [goalCycleSearchTextArray, setGoalCycleSearchTextArray] = useState<string>('');
	const { paginationData } = useSelector((state: any) => state?.adminSettingReducer);
	const [workflowReversalCycleList, setWorkflowReversalCycleList] = useState([]);
	const [selectedWorkflowFilterCycleId, setSelectedWorkflowFilterCycleId] = useState<any>(0);

	let defaultFinalSettings: any[] = [];
	const [finalFilterCondition, setFinalFilterCondition] = useState<any>(defaultFinalSettings);
	useEffect(() => {
		getWorkflowReversalCycle();
	}, []);

	// ==============================================================================
	//                Goal Cycle List Start
	// ===============================================================================

	const handleGoalCycleChange = (e: any) => {
		setGoalCycleSearchValue(e.target.value);
	};

	const goalCycleSearchClicked = (e: any) => {
		if (e.key === 'Enter') {
			if (e.target.value && e.target.value.trim() !== '') {
				handleGoalCycleSearch(e.target.value);
			}
			setGoalCycleSearchValue('');
		}
	};

	const handleGoalCycleSearch = (value: any) => {
		setPageIndex(1);
		setGoalCycleSearchTextArray(value);
		setLoader(true);
	};

	const clearGoalCycleSearch = () => {
		setPageIndex(1);
		setGoalCycleSearchTextArray('');
	};

	const handleGoalCycleChangePage = (event: any, newPage: number) => {
		newPage = newPage + 1;
		setPageIndex(newPage);
	};

	const handleGoalCycleChangeRowsPerPage = async (event: any) => {
		const pSize = event.target.value;
		setPageSize(pSize);
		setPageIndex(1);
	};

	const resetSearchAndPagination = () => {
		setPageSize(Enums.TEN);
		setPageIndex(1);
		setGoalCycleSearchTextArray('');
	};

	const handleGoalCycleAction = (record: any, isEdit = false, type: string) => {
		setGoalCycleOpen({ open: true, data: record, type });
	};

	// ==============================================================================
	//                Goal Cycle List End
	// ===============================================================================

	const handleGoalFormAction = (record: any, isEdit = false, type: string) => {
		setGoalFormOpen({ open: true, data: record, type });
	};
	const handleExportGoalFormReport = async () => {
		try {
			const response: any = await dispatch(exportGoalFormListReport(''));
			if (response) {
				const defaultName = 'goalFormList.xlsx';
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				const matches = filenameRegex.exec(response.headers['content-disposition']);
				link.setAttribute('download', matches && matches.length > 0 ? matches[1] : defaultName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			// setListLoading(false);
		} catch (error) {
			console.error(error);
		}
	};

	const getWorkflowReversalCycle = async () => {
		try {
			const response: any = await dispatch(getWorkflowReversalCycleList());
			if (response) {
				if (response && response.data && response.data.status === 200) {
					const { entityList } = response.data;
					if (entityList) {
						let records = entityList;
						if (records && records.length) {
							let recordsCpy = records.map((item: any) => {
								return {
									...item,
									performanceCycleId: item.performanceGoalCycleId,
									name: item.performanceGoalCycleName,
								};
							});
							setWorkflowReversalCycleList(recordsCpy);
							//setGoalSettingReversalReportCycle(recordsCpy[0]);
						} else {
							setWorkflowReversalCycleList([]);
						}
					} else {
						setWorkflowReversalCycleList([]);
					}
				} else {
					setWorkflowReversalCycleList([]);
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	const handleExportGoalCycleReport = async () => {
		try {
			const response: any = await dispatch(exportGoalCycleListReport(''));
			if (response) {
				const defaultName = 'goalCycleList.xlsx';
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				const matches = filenameRegex.exec(response.headers['content-disposition']);
				link.setAttribute('download', matches && matches.length > 0 ? matches[1] : defaultName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			// setListLoading(false);
		} catch (error) {
			console.error(error);
		}
	};

	const handleWorkflowFilterChanged = (value: number) => {
		setSelectedWorkflowFilterCycleId(value);
	};

	const handleWorkflowReversalReport = async () => {
		try {
			const response: any = await dispatch(exportWorkflowReversalReport(''));
			if (response) {
				const defaultName = 'workflowReversalList.xlsx';
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				const matches = filenameRegex.exec(response.headers['content-disposition']);
				link.setAttribute('download', matches && matches.length > 0 ? matches[1] : defaultName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			// setListLoading(false);
		} catch (error) {
			console.error(error);
		}
	};

	const applyFilter = (filterData: any) => {
		setFinalFilterCondition(filterData);
	};
	return (
		<>
			{loader && (
				<Box className='loader-wrap-type1'>
					<LinearLoader />
				</Box>
			)}

			{goalFormOpen && goalFormOpen.open ? (
				<CreateGoalForm {...props} goalFormOpen={goalFormOpen} />
			) : goalCycleOpen && goalCycleOpen.open ? (
				<CreateCycleForm
					{...props}
					loader={loader}
					setLoader={setLoader}
					setTabSelected={setTabSelected}
					resetSearchAndPagination={resetSearchAndPagination}
					goalCycleOpen={goalCycleOpen}
					setGoalCycleOpen={setGoalCycleOpen}
				/>
			) : workflowReversalOpen && workflowReversalOpen.open ? (
				<GoalWorkflow setTabSelected={setTabSelected} setWorkflowReversalOpen={setWorkflowReversalOpen} />
			) : (
				<Box className='align-settings'>
					<Box className='admin-tabpanel-inner'>
						<Box className='admin-tabpanel-head'>
							<Box className='admin-tabpanel-head-left'>
								<AlignGoalsSettingsTab
									a11yProps={a11yProps}
									tabSelected={tabSelected}
									handleTabChange={(event: any, newValue: Number) => {
										resetSearchAndPagination();
										handleTabChange(event, newValue);
									}}
								/>
							</Box>
							{/* {tabSelected !== 2 && ( */}
							<Box className='admin-tabpanel-head-right align-goals-head-right'>
								<>
									{paginationData && paginationData?.totalRecords && (
										<Box>
											<TablePagination
												component='div'
												className='user-list-pagination'
												count={paginationData?.totalRecords}
												page={pageIndex > 1 ? pageIndex - 1 : 0}
												onPageChange={handleGoalCycleChangePage}
												rowsPerPage={pageSize}
												onRowsPerPageChange={handleGoalCycleChangeRowsPerPage}
												SelectProps={{
													MenuProps: {
														PopoverClasses: { paper: 'okr-default-dropdown user-number-dropdown' },
													},
												}}
											/>
										</Box>
									)}
									{paginationData && paginationData?.totalRecords && tabSelected === 2 && (
										<WorkflowReversalCycleFilter
											workflowReversalCycleList={workflowReversalCycleList}
											handleWorkflowFilterChanged={handleWorkflowFilterChanged}
											selectedWorkflowFilterCycleId={selectedWorkflowFilterCycleId}
											setFinalFilterCondition={applyFilter}
											finalFilterCondition={finalFilterCondition}
										/>
									)}
									{!(paginationData && paginationData?.totalRecords) &&
									goalCycleSearchValue === '' &&
									goalCycleSearchTextArray.length === 0 ? (
										<></>
									) : (
										<Box className='user-search'>
											<TextField
												className='search-text-field'
												id='user-src-field'
												placeholder={t('cycleSearchPlaceHolder')}
												fullWidth
												value={goalCycleSearchValue}
												onChange={(e) => handleGoalCycleChange(e)}
												onKeyDown={(e) => goalCycleSearchClicked(e)}
												InputProps={{
													startAdornment: (
														<InputAdornment position='start'>
															<SearchIcon />
														</InputAdornment>
													),
												}}
											/>
											{goalCycleSearchTextArray && (
												<Box className='user-search-chip'>
													<List>
														<ListItem>
															{goalCycleSearchTextArray.length > 20 ? (
																<Tooltip title={goalCycleSearchTextArray} arrow>
																	<Chip
																		label={goalCycleSearchTextArray.substring(0, 20) + '...'}
																		onDelete={clearGoalCycleSearch}
																		deleteIcon={
																			<span>
																				<CrossIcon />
																			</span>
																		}
																	/>
																</Tooltip>
															) : (
																<Chip
																	label={goalCycleSearchTextArray}
																	onDelete={clearGoalCycleSearch}
																	deleteIcon={
																		<span>
																			<CrossIcon />
																		</span>
																	}
																/>
															)}
														</ListItem>
													</List>
												</Box>
											)}
										</Box>
									)}
									{paginationData?.totalRecords > 0 && (
										<Box className='align-goals-download'>
											<OKRButton
												className='btn-circle-white download-btn'
												icon={<DownloadIcon />}
												title={
													tabSelected === 1
														? t('downloadGoalFormsDetails')
														: tabSelected === 2
														? t('downloadWorkflowReversalDetails')
														: t('downloadGoalCycleDetails')
												}
												handleClick={
													tabSelected === 1
														? handleExportGoalFormReport
														: tabSelected === 2
														? handleWorkflowReversalReport
														: handleExportGoalCycleReport
												}
											></OKRButton>
										</Box>
									)}
								</>
							</Box>
							{/* //)} */}
						</Box>
						<SettingsTabPanel value={tabSelected} index={0}>
							<GoalCyclesList
								{...props}
								goalCycleSearchTextArray={goalCycleSearchTextArray}
								pageIndex={pageIndex}
								pageSize={pageSize}
								setLoader={setLoader}
								setPaginationData={setPaginationData}
								setPageIndex={setPageIndex}
								handleGoalCycleAction={handleGoalCycleAction}
								loader={loader}
							/>
						</SettingsTabPanel>
						<SettingsTabPanel value={tabSelected} index={1}>
							<GoalsFormsList
								goalCycleSearchTextArray={goalCycleSearchTextArray}
								clearGoalCycleSearch={clearGoalCycleSearch}
								pageIndex={pageIndex}
								pageSize={pageSize}
								handleGoalFormAction={handleGoalFormAction}
								setLoader={setLoader}
							/>
						</SettingsTabPanel>
						<SettingsTabPanel value={tabSelected} index={2}>
							<WorkflowReversalList
								goalCycleSearchTextArray={goalCycleSearchTextArray}
								pageIndex={pageIndex}
								pageSize={pageSize}
								setLoader={setLoader}
								selectedWorkflowFilterCycleId={selectedWorkflowFilterCycleId}
								finalFilterCondition={finalFilterCondition}
							/>
						</SettingsTabPanel>
					</Box>
				</Box>
			)}
		</>
	);
};
